module.exports = __webpack_public_path__ + "static/media/rubber1_seamless.eb6f71f2.png";